import { titles } from '../../../../web/styles/colors';
import { BreakPoints } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	button: {
		margin: '30px auto',
	},
	container: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		overflowY: 'auto',
		padding: '30px 0',
		[BreakPoints.tabletCompactHeight]: {
			padding: 20,
		},
	},
	content: {
		textAlign: 'center',
	},
	message: {
		color: '#4a4a4a',
		fontSize: 14,
		maxWidth: 500,
	},
	title: {
		color: titles,
		fontSize: 24,
		padding: 20,
	},
});
